import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// VUEX Store
export default new Vuex.Store({
  state: {
    settings_json: {},
    rules_json: {},
    paymentSettings: [],
    platformFeeSettings: [],
  },
  actions: {

    async GET_JSON(context, payload) {
      try {
        const settingsResponse = await fetch('/vue/dev/utilities/payment_settings.json');
        const settingsJson = await settingsResponse.json();

        const rulesResponse = await fetch('/vue/dev/utilities/payment_rules.json');
        const rulesJson = await rulesResponse.json();

        context.commit('SET_SETTINGS_JSON', settingsJson);
        context.commit('SET_RULES_JSON', rulesJson);
      } catch (error) {
        console.error('Error!', error);
      }
    },

    async GET_PAYMENT_SETTINGS(context, payload) {
      try {
        const url = '/api/v4/parent/payments/payment-settings';
        const request = new Request(url, { method: 'GET', credentials: 'same-origin' });
        const response = await fetch(request);
        const json = await response.json();
        context.commit('SET_PAYMENT_SETTINGS', json.data);
        context.commit('SET_PLATFORM_FEE_SETTINGS', json.absorbCharges);
      } catch (e) {
        console.error('Error!', e);
      }
    },

    async UPDATE_SETTING(context, payload) {
      try {
        const route = Routing.generate('ApiBundle_update_payment_settings');
        const request = { method: 'POST', body: JSON.stringify({ setting: payload.setting, value: payload.value }) };
        const response = await fetch(route, request);
        const json = await response.json();
        context.commit('UPDATE_PAYMENT_SETTINGS', json.data);
      } catch (e) {
        console.error('Error!', e);
      }
    },

    async UPDATE_PLATFORM_FEES_SETTING(context, payload) {
      try {
        const route = Routing.generate('ApiBundle_update_platform_fees');
        const request = { method: 'POST' };
        const response = await fetch(route, request);
        const json = await response.json();
        context.commit('UPDATE_PLATFORM_FEE_SETTINGS', json.data);
      } catch (e) {
        console.error('Error!', e);
      }
    },

  },
  mutations: {
    SET_SETTINGS_JSON(state, payload) {
      state.settings_json = payload;
    },

    SET_RULES_JSON(state, payload) {
      state.rules_json = payload;
    },

    SET_PAYMENT_SETTINGS(state, payload) {
      state.paymentSettings = payload;
    },

    SET_PLATFORM_FEE_SETTINGS(state, payload) {
      state.platformFeeSettings = payload;
    },

    UPDATE_PAYMENT_SETTINGS(state, payload) {
      state.paymentSettings = payload;
    },
    UPDATE_PLATFORM_FEE_SETTINGS(state, payload) {
      state.platformFeeSettings = payload;
    },

  },

  getters: {

    settingsJson(state) {
      return state.settings_json;
    },

    rulesJson(state) {
      return state.rules_json;
    },

    absorbCharges(state) {
      return state.platformFeeSettings;
    },

    paymentSettings(state) {
      return state.paymentSettings;
    },
  },

});
